import { Spinner, TextInput } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Connect from 'modules/User/Accounts/Connect'
import Logout from 'modules/User/Accounts/Logout'
import Refresh from 'modules/User/Accounts/Refresh'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const FormGroup = ({ value }) => {
  const { t } = useTranslation()
  const { sm } = useBreakpoint()
  const { i18n, accounts: { loading } = {} } = useSelector((state) => ({
    i18n: state['app'].i18n,
    accounts: state['user/accounts'],
  }))

  const ConnectButton = useMemo(() => {
    switch (value?.status) {
      case 'expired':
        return Refresh

      case 'connected':
        return Logout

      default:
        return Connect
    }
  }, [value?.status])

  return (
    <TextInput
      autocomplete="off"
      fullWidth
      placeholder={!loading ? t('user::settings.accounts.connectAccount') : ''}
      label={`${t('user::settings.profile.label')} ${t('user::settings.profiles.admitad')}`}
      type="text"
      value={value?.username}
      readOnly
      helperText={sm && <ConnectButton i18n={i18n} />}
      InputProps={{
        startAdornment: loading ? (
          <Spinner
            width={16}
            color={'Label-GU-Primary'}
          />
        ) : null,
        endAdornment: !sm && (
          <ConnectButton
            i18n={i18n}
            asButton={true}
          />
        ),
      }}
    />
  )
}

FormGroup.propTypes = {
  key: PropTypes.string,
  profile: PropTypes.string,
  value: PropTypes.shape({
    status: PropTypes.string,
    username: PropTypes.string,
  }),
}
export default FormGroup
